export default {"src":"/_next/static/media/black-north-arrow.c0c0d37b.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};